import { ALL_VALUE, RESULT_TYPES, PITCH_TYPES } from './constants';

const filterStringOrNull = (v) => (v === '' ? null : v);

export default (filter, levels) => ({
    baseState: filter.baseState >= 0 ? filter.baseState : null,
    counts: filter.counts.includes(ALL_VALUE) ? null : filter.counts,
    result: filter.result.includes(ALL_VALUE) || filter.result.length === RESULT_TYPES.length ? null : filter.result,
    pitchTypes: filter.pitchTypes.includes(ALL_VALUE) || filter.pitchTypes.length === PITCH_TYPES.length ? null : filter.pitchTypes,
    throws: filter.pitcherHand > 0 ? filter.pitcherHand : null,
    bats: filter.batterHand > 0 ? filter.batterHand : null,
    pitchLocation: filter.pitchLocation.length === 0 ? null : filter.pitchLocation,
    zoneLocation: filter.zoneLocation === ALL_VALUE ? null : filter.zoneLocation,
    minVelo: filterStringOrNull(filter.minVelo),
    maxVelo: filterStringOrNull(filter.maxVelo),
    minLa: filterStringOrNull(filter.minLa),
    maxLa: filterStringOrNull(filter.maxLa),
    minEv: filterStringOrNull(filter.minEv),
    maxEv: filterStringOrNull(filter.maxEv),
    minHorizLa: filterStringOrNull(filter.minHorizLa),
    maxHorizLa: filterStringOrNull(filter.maxHorizLa),
    minBreakX: filterStringOrNull(filter.minBreakX),
    maxBreakX: filterStringOrNull(filter.maxBreakX),
    minBreakZ: filterStringOrNull(filter.minBreakZ),
    maxBreakZ: filterStringOrNull(filter.maxBreakZ),
    minRelX: filterStringOrNull(filter.minRelX),
    maxRelX: filterStringOrNull(filter.maxRelX),
    minRelZ: filterStringOrNull(filter.minRelZ),
    maxRelZ: filterStringOrNull(filter.maxRelZ),
    levelIds: levels.filter((l) => !!l.checked).map((l) => l.value),
    minArmAngle: filterStringOrNull(filter.minArmAngle),
    maxArmAngle: filterStringOrNull(filter.maxArmAngle),
    minGyroDegree: filterStringOrNull(filter.minGyroDegree),
    maxGyroDegree: filterStringOrNull(filter.maxGyroDegree),
    lastPAs: filter.lastPAs > 0 ? filter.lastPAs : null,
    park: filter.park && filter.park !== ALL_VALUE ? filter.park : null,
    timing: filter.timing.includes(ALL_VALUE) || filter.timing.length === 0 ? null : filter.timing,
});
